import * as React from 'react';
import { connect } from 'react-redux';
import { alphabeticalSortingComparator } from 'stageclip-common';

import { DataRequestActionTypes } from '../../constants/actionTypes';
import { FormId } from '../../constants/formId';
import { NormalizedClient } from '../../models/normalized/normalizedClient';
import { ClippingPlatformState } from '../../store/clippingPlatformState';
import { getAll } from '../../store/selectors';
import { baseMapDispatchToProps, ComponentBase, BaseDispatchProps, BaseStateProps } from '../componentBase';
import { mapBaseEventStateToProps } from '../events/baseEventForm';
import { AppSelectField } from '../form/appSelectField';
import { required } from '../form/formValidations';
import FormModal from '../modal/formModal';

interface CopyClipTemplateConfigFromClientStateProps extends BaseStateProps {
  clients: NormalizedClient[];
}

class CopyClipTemplateConfigFromClient extends ComponentBase<
  {},
  CopyClipTemplateConfigFromClientStateProps,
  BaseDispatchProps
> {
  protected loggedInRender() {
    return (
      <FormModal
        formId={FormId.CopyClipConfigurationFromClient}
        formTitle="Copy clip configuration from client"
        submitActionType={DataRequestActionTypes.CopyClipConfigurationFromClientRequested}
        smallButton
        hideButton
      >
        <AppSelectField
          name="clientClipConfiguration"
          label="Client"
          validate={[required]}
          options={this.getClientsOption()}
        />
      </FormModal>
    );
  }

  private getClientsOption() {
    return this.props.clients
      .sort((a: any, b: any) => alphabeticalSortingComparator(a.name, b.name))
      .map((client: NormalizedClient) => ({ value: client.clipConfiguration, label: client.name }));
  }
}

function mapStateToProps(state: ClippingPlatformState): CopyClipTemplateConfigFromClientStateProps {
  return {
    ...mapBaseEventStateToProps(state),
    clients: getAll(state.entities.clients),
  };
}

export default connect(mapStateToProps, baseMapDispatchToProps)(CopyClipTemplateConfigFromClient);
